<template lang="pug">
.Header
    .inner
        h1 Find my School
        .logos
            img(src="/de-education-state-logo.png" height="60" class="education-state-logo" alt="The Education State, Victoria State Government, Department of Education")
</template>

<script>
export default {
    name: 'Header',
    data: () => ({}),
    created() {
        window.Header = this;
    },
};
</script>

<style scoped>
.Header {
    background-color: white;
    color: #af272f;
}

.Header h1 {
    /* margin: 1em; */
    /* font-family: VIC, Open Sans, Arial; */
    font-family: VIC, Avenir, Helvetica, Arial, sans-serif;
    font-weight: bold;
    font-size: 12pt;
    padding: 0 0.75em;
    margin: 0;
}

@media screen and (min-width: 768px) {
    .Header h1 {
        font-size: 16pt;
    }
}

.inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 5px;
    padding-bottom: 5px;
}

.logos {
    margin-right: 0.75em;
    display: flex;
}

.logos img {
    height: 40px;
}

.education-state-logo {
    display: none;
    height: 40px;
}

@media screen and (min-width: 768px) {
    .logos img {
        height: 60px;
    }
    .education-state-logo {
        display: block;
    }
}

@media screen and (min-width: 375px) {
    .inner {
        margin: 0.5em 0;
    }
}
</style>

<style>
@media print {
    .Header {
        display: none !important;
    }
}
</style>
